export const RemunerationType = {
  MONTHLY: 'MONTHLY',
  YEARLY: 'YEARLY',

  values: () => {
    return ['MONTHLY', 'YEARLY'];
  }
};
